export class InfiniteArray {
  constructor(list) {
    this.list = list;
    this.length = list.length;
  }

  get(index) {
    return this.list[(index + this.length) % this.length];
  }
}
